export default {
    coaches(state){
        return state.coaches;
    },
    hasCoaches(state){
        return state.coaches && state.coaches.length >0;
    },
    //isCoach(state, getters, rootState, rootGetters){
    isCoach(_, getters, _2, rootGetters){//사용되지 않는 변수 _ 로
        const coaches = getters.coaches;
        const userId = rootGetters.userId;
        return coaches.some(coach => coach.id === userId);
        //some: 함수는 배열의 요소 중 하나라도 callbackFunction에서 true를 리턴하면 true를 리턴
    }
}
